// ── Activity type registry ───────────────────────────────────────────────────
// Keep this file as the canonical enum so other modules import from here.
export const ACTIVITY_TYPES = {
  FLASHCARD:      'flashcard',
  SEQUENCING:     'sequencing',
  MATCHING:       'matching',
  CATEGORIZATION: 'categorization',
  PATTERN:        'pattern',   // reserved for future use
};

// Cartoon sprite panel helper.
// Usage: sprite('brushing-teeth.jpg', col, row, totalCols, totalRows)
// The image file lives at public/images/sequencing/<file>.
// eslint-disable-next-line no-unused-vars
const sprite = (file, col, row, cols, rows = 1) => ({
  src: `/images/sequencing/${file}`,
  col, row, cols, rows,
});

// ── Built-in sequencing decks ────────────────────────────────────────────────
// Each step has a stable `id`, its correct `order` (1-based), a short `label`,
// and either an `image` URL or an `emoji` fallback.
// Add real image URLs to `image` when they are available — the card renderer
// always prefers `image` over `emoji`.

export const SEQUENCING_DECKS = [
  // Static decks removed — all content now lives in generatedSequencingDecks in Firestore.

];

// ── Categories ───────────────────────────────────────────────────────────────
// Extend this list as more decks are added — used for filtering UI.
export const SEQUENCING_CATEGORIES = [
  'Hygiene',
  'Daily Living',
  'Social Skills',
  'Community',
  'Safety',
  'Cooking',
  'Life Cycles',
  'Academic',
  'Patterns',
  'First / Next / Last',
  'Before / After',
];
